/* eslint-disable @typescript-eslint/naming-convention -- HTTP header names */
import type { SharingProps } from '@ori/sharing-panel';
import axios from 'axios';

import { logDebug } from './log';

export const getSharedContent = async () => {
  const contentInfoUrl = '/system/ajax/CustomerOrderDetail/GetBasketLink';
  logDebug('Loading shared content ...');
  const response = await axios.get<SharingProps>(`${window.location.origin}${contentInfoUrl}`, {
    headers: {
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'Service-Worker-Allowed': '/',
      Pragma: 'no-cache',
      Expires: '0',
    },
  });
  const { data } = response;
  const message = data.message.replace(/\n\n, /g, ', \n\n').replace(/\n{3}/g, '\n\n');
  const result = { ...data, message };
  logDebug('getSharedContent() data:', result);

  return result;
};
